import {createAsyncThunk, createSlice, PayloadAction} from "@reduxjs/toolkit";
import { Averages, BestOfXLegs, Checkouts, IScoreBoardAndStatsResp, IScoreBoardAndStatsState, LegByLeg, Rounds } from "./types";
import IDartsGameIdType from "../../../common/interfaces/IDartsGameIdType";
import {toastr} from "react-redux-toastr";
import { API_DARTS_SCOREBOARD_STATS } from "../../../services/api/api.urls";
import { api } from "../../../services/api/api.service";
import { COMPANY_ABBR } from "../../../common/constants/company";
import { TryCatch } from "../../../services/TryCatch";

const initialState: IScoreBoardAndStatsState = {
    scoreBoardAndStatsInfo: {
        doubleMissed: {
            currentLeg:0,
            scores:[0,0]
        },
        turns180:{
            series180:0,
            week180:0,
        },
        playersInfo: {
            playersInfo: []
        },
        bestOfXLegs: {
            players: [],
            legs: [],
            score: [],
            numThrows: [],
            title: "",
            firstPlayerId: null,
            nextPlayerId: 0,
            is180PlayerId: null,
            legsToWin: 0
        },
        ligaTable: {
            name: "",
            tournamentId: 0,
            table: {
                items: []
            }
        },
        legByLeg: {
            maxLeg: 0,
            totalDarts: []
        },
        averages: {
            average: [],
            turn180: []
        },
        rounds: {
            titles: [],
            data: [
                [],
                []
            ]
        },
        checkouts: {
            checkouts: [],
            highestCheckout: []
        }
    },
    statsLoader: true,
    currentGameId: 0,
}

export const getScoreboardStatsInit = createAsyncThunk<IScoreBoardAndStatsResp, IDartsGameIdType, { rejectValue: string }>(
    'scoreboardAndStats/schedule',
    async (gameParams, {rejectWithValue}) => {
        const {gameId, gameType} = gameParams;
        const result = await TryCatch(
            () => api.get(`${API_DARTS_SCOREBOARD_STATS}/${gameType}/${gameId}`).then(res => res.data)
        );
        if (!result.success) {
            toastr.error(COMPANY_ABBR, 'Scoreboard and stats failed.');
            return rejectWithValue(result.error);
        }
        return result.data;
    }
)

export const scoreboardAndStatsSlice = createSlice({
    name: 'scoreboardAndStats',
    reducers: {
        setCurrentGameId: (state, action: PayloadAction<number>) => {
            state.currentGameId = action.payload;
        },

        updateBestOf7LegsBySocket: (state, action: PayloadAction<BestOfXLegs>) => {
            state.scoreBoardAndStatsInfo.bestOfXLegs = action.payload;
        },
        updateAveragesBySocket: (state, action: PayloadAction<Averages>) => {
            state.scoreBoardAndStatsInfo.averages = action.payload;
        },
        updateCheckoutBySocket: (state, action: PayloadAction<Checkouts>) => {
            state.scoreBoardAndStatsInfo.checkouts = action.payload;
        },
        updateLegByLegBySocket: (state, action: PayloadAction<LegByLeg>) => {
            state.scoreBoardAndStatsInfo.legByLeg = action.payload;
        },
        updateRoundsBySocket: (state, action: PayloadAction<Rounds>) => {
            state.scoreBoardAndStatsInfo.rounds = action.payload;
        },
        updatePlayersInfoBySocket: (state, action) => {
            state.scoreBoardAndStatsInfo.playersInfo = action.payload
        },
        setDoubleMissed: (state, action) => {
            state.scoreBoardAndStatsInfo.doubleMissed = action.payload
        },
        setTurn180BySocket:(state, action) => {
            state.scoreBoardAndStatsInfo.turns180 = action.payload
        }
    },

    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(getScoreboardStatsInit.pending, (state: IScoreBoardAndStatsState) => {
                state.statsLoader = true;
            })
            .addCase(getScoreboardStatsInit.fulfilled, (state: IScoreBoardAndStatsState, action) => {
                state.scoreBoardAndStatsInfo = action.payload
                state.statsLoader = false;
            })
            .addCase(getScoreboardStatsInit.rejected, (state: IScoreBoardAndStatsState) => {
                state.statsLoader = false;
            })
    }
})

export const {
    setCurrentGameId,
    updateAveragesBySocket,
    updateCheckoutBySocket,
    updateBestOf7LegsBySocket,
    updateLegByLegBySocket,
    updateRoundsBySocket,
    updatePlayersInfoBySocket,
    setDoubleMissed,
    setTurn180BySocket
} = scoreboardAndStatsSlice.actions;
export default scoreboardAndStatsSlice.reducer;
